import { useIntl } from 'react-intl';
import { components, MenuProps, OptionProps } from 'react-select';
import React from 'react';
import { ReactComponent as ArrowRightIcon } from '@whitelabel/media/icons/small/arrow-right.svg';
import { ReactComponent as SelectedIcon } from '@whitelabel/media/icons/flags/selected-flag.svg';
import commonMessages from '@whitelabel/helpers/messages/commonMsg';
import { getCurrencySymbolOrName } from '@whitelabel/helpers/utils';
import Button from '../Button';
import { StyledIcon, StyledDivider, StyledSelectOption, MenuFooterWrapper } from './styledCurrencySelect';

interface ISelectOptionProps {
  isSelected: boolean;
  icon: React.FunctionComponent<React.PropsWithChildren<unknown>>;
  label: string;
  isHidden: boolean;
  isFirstOption: boolean;
  isLastOption: boolean;
}

export const CustomMenu = (props: MenuProps<any, false>): JSX.Element => {
  const {
    selectProps: { setIsCurrencyListModalOpen },
    children,
  } = props;
  const { formatMessage } = useIntl();
  return (
    <>
      <components.Menu {...props}>
        <>
          {children}
          <MenuFooterWrapper>
            <StyledDivider />
            <Button
              onClick={() => {
                setIsCurrencyListModalOpen(true);
              }}
              buttonType="tertiary"
              icon={ArrowRightIcon}
            >
              {formatMessage(commonMessages.more)}
            </Button>
          </MenuFooterWrapper>
        </>
      </components.Menu>
    </>
  );
};

export const SelectOption = ({ isSelected, icon, label, isHidden, isFirstOption, isLastOption }: ISelectOptionProps) =>
  !isHidden ? (
    <StyledSelectOption isSelected={isSelected} isFirstOption={isFirstOption} isLastOption={isLastOption}>
      <StyledIcon as={isSelected ? SelectedIcon : icon} /> {label}
    </StyledSelectOption>
  ) : null;

export const CustomOption = (props: OptionProps<any, false, any>): JSX.Element => {
  const {
    selectProps: { selectedCurrency },
    innerProps,
    innerProps: { id },
    data: { value, icon, hiddenFromList },
  } = props;
  const { locale } = useIntl();
  return (
    <div {...innerProps}>
      <SelectOption
        isSelected={value === selectedCurrency}
        icon={icon}
        label={`${value} (${getCurrencySymbolOrName(locale, value)})`}
        isHidden={hiddenFromList}
        isFirstOption={id.endsWith('0')}
        isLastOption={id.endsWith('3')}
      />
    </div>
  );
};
